document.addEventListener('DOMContentLoaded', () => {
  // Setup elements
  const cartDialog = document.getElementById('cartDialog');
  const openCartBtn = document.getElementById('openCartBtn');

  // Open cart handler
  const openCart = () => {
    cartDialog.classList.remove('animate-dialog-open');

    if (typeof cartDialog.showModal === 'function') {
      cartDialog.showModal();
    } else {
      // Fallback for browsers that do not support dialog.showModal()
      cartDialog.style.display = 'block';
    }

    // Animate the dialog after it's opened
    requestAnimationFrame(() => {
      cartDialog.classList.add('animate-dialog-open');
    });
  };

  // Open cart when the cart is updated
  document.body.addEventListener('cart:updated', (event) => {
    const { shouldOpenCart } = event.detail;
    if (shouldOpenCart) {
      openCart();
    }
  });

  // Rebuild the cart when the cart is updated
  document.body.addEventListener('cart:rebuild', (event) => {
    const { html } = event.detail;
    const container = document.createElement('div');
    container.innerHTML = html;
    const cartDrawer = container.querySelector('#cartDialog');
    cartDialog.innerHTML = cartDrawer.innerHTML;
  });

  // Open when clicking the open button
  openCartBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  });

  // Close when clicking outside of it
  cartDialog?.addEventListener('click', (event) => {
    if (event.target === cartDialog) {
      cartDialog.close();
    }
  });
});
